import {useSelector} from 'react-redux';

/**
 * True only for the SUPERADMIN role. The shortcuts/history feature — including
 * registering re-triggerable actions and filters — is limited to super admins,
 * so pages use this to gate whether they contribute anything to it.
 */
export const useIsSuperAdmin = () =>
  useSelector(
    state => state?.auth?.userData?.user?.activeAdminTab?.name === 'SUPERADMIN',
  );
